/**
 * SDK Configuration Debugger
 * 
 * This file is used to apply a global hook to intercept and log SDK configuration responses
 * to help debug issues with React Query's onSuccess callback not being called.
 */

// Initialize the debug log storage if not already present
if (!window.sdkDebugLogs) {
  window.sdkDebugLogs = [];
}

// Add a logging function to the window for easy access from the console
window.logSDKDebug = (message, data) => {
  const logEntry = {
    timestamp: new Date().toISOString(),
    message,
    data
  };
  console.log('[SDK Debug]', logEntry);
  window.sdkDebugLogs.push(logEntry);
};

// Function to intercept API responses to /sdk-config endpoints
export const installSDKDebugger = () => {
  if (window.sdkDebuggerInstalled) return;
  
  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
    const response = await originalFetch.apply(this, args);
    
    // Create a clone so we can read the body twice
    const clone = response.clone();
    
    try {
      // Check if this is an SDK config request
      const url = args[0]?.url || args[0];
      if (typeof url === 'string' && url.includes('sdk-config')) {
        window.logSDKDebug('SDK Config request detected', { url, args });
        
        // Try to parse the response body as JSON
        const responseData = await clone.json();
        window.logSDKDebug('SDK Config response received', responseData);
      }
    } catch (err) {
      // Silently fail - we don't want to break normal application flow
      console.error('Error in SDK debugger:', err);
    }
    
    return response;
  };
  
  window.sdkDebuggerInstalled = true;
  window.logSDKDebug('SDK Debugger installed', { timestamp: new Date().toISOString() });
};

// Automatically install the debugger when this file is imported
try {
  installSDKDebugger();
} catch (err) {
  console.error('Error installing SDK debugger:', err);
}

export default {
  getLogs: () => window.sdkDebugLogs || [],
  clearLogs: () => {
    window.sdkDebugLogs = [];
    console.log('SDK debug logs cleared');
  }
}; 